<p-toast></p-toast>
<p-confirmDialog key="confirmDialog"></p-confirmDialog>

<p-panel *ngIf="status != ''">
  <p-header>
    <div class="flex flex-row justify-content-between">
      <span class="text-xl font-bold">Conversation inaccessible</span>
    </div>
  </p-header>
  <p-body>
    <p>{{status}}</p>
  </p-body>
</p-panel>

<p-card *ngIf="!EstCharge()">
  <div class="fluid formgrid grid">
    <div class="flex flex-column gap-2 my-2 col-12 text-center">
      <p-progressSpinner></p-progressSpinner>
    </div>
  </div>
</p-card>

<div *ngIf="EstCharge() && status == ''" #scrollContainer class="my-2 remaining-height overflow-y-auto"
  (scroll)="onScroll()">
  <div class="flex flex-row justify-content-end">
    <p-button (onClick)="op.toggle($event); ObtenirEmployes()" icon="pi pi-user" [text]="true" [outlined]="true"
      label="Membres de la conversation" />
    <p-overlayPanel #op>
      <div *ngFor="let member of conversation.membres" class="flex justify-content-between gap-1 my-2">
        <app-user-info [employe]="member.employe"></app-user-info>
        <p-button (onClick)="supprimerMembre(member.employe.employeId)" icon="pi pi-times" severity="danger"
          [text]="true" [outlined]="true" />
      </div>
      <div class="my-2">
        <p-button (onClick)="ajouterMembre()" icon="pi pi-plus" text label="Ajouter un membre" />
      </div>
    </p-overlayPanel>
  </div>
  <p-dataView #dv [value]="messages" [paginator]="false" sortField="date" sortOrder="1">
    <ng-template pTemplate="list" let-messagess>
      <div *ngFor="let message of messagess; let last = last" class="p-2 message-item mx-auto" style="max-width: 1500px;"
        [attr.data-message-id]="message.messageId">
        <div
          [style]="{'margin-left': isOwner(message) ? '5rem' : (isSystemMessage(message) ? '2rem' : '0'), 'margin-right': isOwner(message) ? '0' : (isSystemMessage(message) ? '2rem' : '5rem')}">
          <div class="flex flex-wrap" [style]="{'justify-content': isOwner(message) ? 'flex-end' : (isSystemMessage(message) ? 'space-between' : 'space-between')}">
            <app-user-info *ngIf="!isOwner(message) && !isSystemMessage(message)" [employe]="message.employe" [loading]="!message.texte" />
            <div *ngIf="isSystemMessage(message)" class="flex align-items-center gap-2 py-1">
              <i class="pi pi-cog text-sm"></i>
              <span class="text-sm font-medium opacity-80">Message système</span>
            </div>
            <div class="flex flex-row align-items-end justify-content-end gap-2">
              <p-chip *ngIf="message.dateRappel">
                <div class="flex align-items-center gap-2">
                  <i class="pi pi-bell"></i>
                  <span>Rappel <b>{{message.rappelEnvoye ? 'envoyé' : ''}}</b> le {{message.dateRappel |
                    date:'yyyy-MM-dd HH:mm'}}</span>
                </div>
              </p-chip>
              <small *ngIf="message.date" class="mr-2">{{message.date | date:'yyyy-MM-dd HH:mm'}}</small>
              <p-skeleton *ngIf="!message.date" width="50px"></p-skeleton>
              <p-button *ngIf="isOwner(message) && !message.isEditing" icon="pi pi-ellipsis-h" [text]="true" text
                pTooltip="Plus d'options" tooltipPosition="bottom" styleClass="p-0"
                (onClick)="onShowMenu(message, $event)" />
              <p-button *ngIf="message.isEditing" icon="pi pi-check" pTooltip="Valider" tooltipPosition="bottom"
                (onClick)="confirmEditMessage()" />
              <p-button *ngIf="message.isEditing" icon="pi pi-times" pTooltip="Annuler" [text]="true" [outlined]="true"
                tooltipPosition="bottom" (onClick)="cancelEditMessage(message)" />
              <p-menu #menu [model]="items" [popup]="true" [appendTo]="'body'" [style]="{'width': '14rem'}" />
            </div>
          </div>
          <p-card [styleClass]="'mt-2 ' + (isOwner(message) ? 'message-owner' : (isSystemMessage(message) ? 'message-system' : 'message-other'))">
            <p-skeleton *ngIf="!message.texte" width="100%"></p-skeleton>
            <sihc-quill-view *ngIf="!message.isEditing" [modules]="sdb.modules" [content]="message.texte"
              [style]="{'min-height': '50px !important', 'max-height': '300px', 'overflow': 'hidden', 'overflow-y': 'scroll' }"></sihc-quill-view>
            <quill-editor *ngIf="message.isEditing" placeholder="Ecrivez votre message ici..." [modules]="sdb.modules"
              [(ngModel)]="messageToEdit.texte"></quill-editor>
            <p-fileUpload *ngIf="message.isEditing" #fileUploadMessage name="myfile[]" styleClass="mt-3"
              multiple="multiple" customUpload="true" maxFileSize="209715200"
              invalidFileSizeMessageSummary="{0}: Fichier trop volumineux, "
              invalidFileSizeMessageDetail="la grosseur maximale est {0}.">
              <ng-template pTemplate="header" let-files let-chooseCallback="chooseCallback"
                let-clearCallback="clearCallback">
                <p-button *ngIf="message.isEditing" class="ml-3" icon="pi pi-plus" [text]="true" [outlined]="true"
                  pTooltip="Ajouter un document" tooltipPosition="bottom" (click)="chooseCallback()" />
              </ng-template>
              <ng-template pTemplate="content" let-files let-uploadedFiles="uploadedFiles"
                let-removeFileCallback="removeFileCallback" let-removeUploadedFileCallback="removeUploadedFileCallback">
                <p-chip *ngFor="let document of files" [removable]="true" (onRemove)="removeFileCallback(document)"
                  styleClass="mb-3">
                  <div class="flex flex-row align-items-center gap-3">
                    <p-image *ngIf="document?.objectURL" [src]="document.objectURL" [preview]="true"
                      [style]="{width: '32px', height: '32px'}" />
                    <span *ngIf="!document?.objectURL" class="pi pi-file"></span>
                    <div class="flex flex-column">
                      <span>{{document.name}}</span>
                      <p-badge *ngIf="document.convertedFromHeic" value="HEIC→JPEG" severity="info"
                        styleClass="text-xs"></p-badge>
                    </div>
                  </div>
                </p-chip>
              </ng-template>
              <ng-template pTemplate="file"></ng-template>
              <ng-template pTemplate="empty"></ng-template>
            </p-fileUpload>
            <p-divider *ngIf="message.documents && message.documents?.length > 0"><span
                class="pi pi-file-pdf"></span></p-divider>
            <p-chip *ngFor="let document of message.documents" styleClass="mb-2 mr-2 cursor-pointer"
              (click)="downloadDocument(document)">
              <div class="flex flex-row align-items-center gap-3">
                <p-image *ngIf="document?.apercu" [src]="document.apercu" [preview]="true"
                  [style]="{width: '32px', height: '32px'}" />
                <span *ngIf="!document?.apercu" class="pi pi-file"></span>
                <span>{{document.nomFichier}}</span>
              </div>
            </p-chip>
          </p-card>
        </div>
        <p-divider *ngIf="message.dernierMessageLu && !last" align="center"><b>Nouveaux messages</b></p-divider>
      </div>
    </ng-template>
    <ng-template pTemplate="empty">
      <div class="flex flex-column align-items-center justify-content-center mt-6">
        <span class="pi pi-comment text-4xl"></span>
        <span>Aucun message pour le moment</span>
      </div>
    </ng-template>
  </p-dataView>
</div>

<div *ngIf="status == ''" class="pt-2 pb-4">
  <div class="relative">
    <quill-editor #editor id="message-to-send" class="relative" placeholder="Ecrivez votre message ici..."
      [modules]="sdb.modules" [(ngModel)]="newMessage.texte"></quill-editor>
    <div
      class="flex flex-row flex-wrap md:flex-nowrap gap-1 justify-content-between mt-2 p-3 absolute bottom-0 left-0 right-0">
      <div class="flex flex-row align-items-center flex-grow-1 gap-2">
        <p-button icon="pi pi-plus" [text]="true" [outlined]="true" pTooltip="Ajouter un document"
          tooltipPosition="bottom" (onClick)="triggerFileChoose()" />
      </div>
      <div class="flex flex-row justify-content-end align-items-center gap-2">
        <p-chip *ngIf="newMessage.dateRappel" [removable]="true" (onRemove)="newMessage.dateRappel = null">
          <div class="flex align-items-center gap-2">
            <i class="pi pi-bell"></i>
            <span>Rappel <b>{{newMessage.rappelEnvoye ? 'envoyé' : 'à envoyer'}}</b> le {{newMessage.dateRappel |
              date:'yyyy-MM-dd HH:mm'}}</span>
          </div>
        </p-chip>
        <p-button *ngIf="newMessage.dateRappel == null" icon="pi pi-ellipsis-h" text pTooltip="Plus d'options"
          tooltipPosition="bottom" (onClick)="menu.toggle($event)" />
        <p-menu #menu [model]="menuOptions" [popup]="true" [appendTo]="'body'" [style]="{'width': '14rem'}" />
        <p-button icon="pi pi-send" label="Envoyer" [disabled]="!newMessage.texte || !EstCharge()" [loading]="sending"
          (onClick)="sendMessage()" />
      </div>
    </div>
  </div>
  <p-fileUpload #fileUpload name="myfile[]" multiple="multiple" customUpload="true" maxFileSize="209715200"
    invalidFileSizeMessageSummary="{0}: Fichier trop volumineux, "
    invalidFileSizeMessageDetail="la grosseur maximale est {0}." styleClass="file-upload-outside-editor">
    <ng-template pTemplate="header"></ng-template>
    <ng-template pTemplate="content" let-files let-uploadedFiles="uploadedFiles"
      let-removeFileCallback="removeFileCallback" let-removeUploadedFileCallback="removeUploadedFileCallback">
      <p-chip *ngFor="let document of files" [removable]="true" (onRemove)="removeFileCallback(document)"
        styleClass="mb-3">
        <div class="flex flex-row align-items-center gap-3">
          <p-image *ngIf="document?.objectURL" [src]="document.objectURL" [preview]="true"
            [style]="{width: '32px', height: '32px'}" />
          <span *ngIf="!document?.objectURL" class="pi pi-file"></span>
          <div class="flex flex-column">
            <span>{{document.name}}</span>
            <p-badge *ngIf="document.convertedFromHeic" value="HEIC→JPEG" severity="info"
              styleClass="text-xs"></p-badge>
          </div>
        </div>
      </p-chip>
    </ng-template>
    <ng-template pTemplate="file"></ng-template>
    <ng-template pTemplate="empty"></ng-template>
  </p-fileUpload>
</div>

<p-confirmDialog #cd key="ajouterRappel">
  <ng-template pTemplate="headless" let-message>
    <div class="flex flex-column align-items-center p-5 border-round" style="max-width: 20rem;">
      <div class="border-circle bg-primary inline-flex justify-content-center align-items-center h-3rem w-3rem">
        <i class="pi pi-bell text-2xl"></i>
      </div>
      <span class="font-bold text-2xl block mb-2 mt-4">
        {{ message.header }}
      </span>
      <p>{{ message.message }}</p>
      <p-calendar [(ngModel)]="rappelDate" dateFormat="yy/mm/dd" [showTime]="true" [showButtonBar]="true"
        [showIcon]="true" />
      <div class="flex align-items-center gap-2 mt-4">
        <button pButton label="Ajouter" (click)="cd.accept();" class="w-8rem" [disabled]="!rappelDate">
        </button>
        <button pButton label="Annuler" (click)="cd.reject()" class="p-button-outlined w-8rem ">
        </button>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>